module.exports = __webpack_public_path__ + "img/consulting_home.1ba25a27.jpg";